function CookiesService($cookies, $location) {
  const service = {
    removeOgImpulseCookie() {
      $cookies.remove('og_impulse', { path: '/', domain: service.getDomain() });
    },
    getDomain() {
      const host = $location.host();
      const domainArr = host.split('.');
      const arrLen = domainArr.length;
      let domain = false;

      // Subdomains don't apply when dealing with IPs
      if (host.match(/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/) !== null) {
        return host;
      }

      // Only use domain with domains with `.` Ignore `localhost`
      if (arrLen >= 2) {
        domain = `.${domainArr[arrLen - 2]}.${domainArr[arrLen - 1]}`;
      }

      return domain;
    }
  };
  return service;
}

CookiesService.$inject = ['$cookies', '$location'];

module.exports = CookiesService;
